import { render, staticRenderFns } from "./VideoAlert.vue?vue&type=template&id=343de09a&scoped=true&"
import script from "./VideoAlert.vue?vue&type=script&lang=js&"
export * from "./VideoAlert.vue?vue&type=script&lang=js&"
import style0 from "./VideoAlert.vue?vue&type=style&index=0&id=343de09a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343de09a",
  null
  
)

export default component.exports